"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProCheckDigitGetter = (strategy) => (proId) => {
    var _a, _b;
    return (_b = (_a = strategy.getCheckDigit) === null || _a === void 0 ? void 0 : _a.call(strategy, proId)) !== null && _b !== void 0 ? _b : "";
};
exports.default = createProCheckDigitGetter;
